import { AppTheme } from '@app/styles/theme';
import styled from '@emotion/styled';

import { rem } from '@app/styles/theme/layout';
import { Button } from '@app/shop/components/Button';

export const RemoveButton = styled(Button)`
  padding: 0;
`;

export const QuantitySelect = styled.select<{ isValid?: boolean }>`
  padding: ${rem(6)} ${rem(12)};
  border: 1px solid
    ${({ isValid = true, theme }) =>
      isValid ? '#ccc' : (theme as AppTheme).colors.error};
  border-radius: 2px;
  font: inherit;
`;
